var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9693 16.9985C8.17387 16.9985 5.77983 12.9617 7.64835 9.62693C7.82353 9.33441 8.11549 9.10039 8.40744 8.86637C8.49503 8.80787 8.75779 8.83713 8.87457 8.92488C8.96216 9.01264 8.99136 9.24666 8.96216 9.39292C8.90377 9.59769 8.78699 9.80245 8.6702 9.97796C7.91112 11.3236 7.85272 12.6692 8.64101 14.0148C9.45849 15.3604 10.6847 16.0332 12.2321 15.9454C13.9254 15.8577 15.5896 14.7168 15.8815 12.6107C15.9107 12.4352 15.9399 12.2304 15.9691 12.0549C16.0275 11.7624 16.1735 11.5283 16.5239 11.5283C16.8158 11.5283 17.0494 11.7624 16.991 12.1426C16.9326 12.6984 16.8742 13.2542 16.6698 13.7808C15.9399 15.7407 14.0714 17.0278 11.9693 16.9985Z",
    fill: "#FEA237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7652 7C13.7213 7.08776 15.1227 7.76056 16.1153 9.19392C16.2029 9.34018 16.3197 9.48644 16.2905 9.6327C16.2905 9.80822 16.1737 10.013 16.0569 10.1007C15.9401 10.1885 15.6774 10.1885 15.5314 10.1007C15.327 9.95448 15.1227 9.74972 14.9767 9.54495C13.9256 8.19935 12.1739 7.73131 10.5973 8.37486C10.3346 8.49187 10.0718 8.57963 9.80904 8.66738C9.57548 8.75514 9.4003 8.72589 9.25432 8.52112C9.10835 8.31635 9.13754 8.08234 9.34191 7.96533C9.60467 7.76056 9.89663 7.52654 10.2178 7.40953C10.8017 7.20476 11.3856 7.08776 11.7652 7Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.c57c461c84eacdd39ebc97ca91b9662e.svg";
export { ForwardRef as ReactComponent };